export const formatPhone = (phone: string) => phone.replaceAll(' ', '');
export const formatAuthCode = (code: string) => code.replace(' ', '');
